import * as React from "react";
const SvgFiRrHorseHead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-horse-head_svg__a)">
      <path
        fill="#062147"
        d="M13.5 13a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1-.001 3m8.803.887c-.215-.19-.409-.37-.564-.526-1.852-1.852-3.105-4.005-4.211-5.904-.873-1.5-1.636-2.81-2.527-3.614V.814A.822.822 0 0 0 13.956.03a4 4 0 0 0-2.876 3.073C2.391 4.057 0 11.488 0 16v7a1 1 0 0 0 2 0v-7c0-1.126.309-11 11-11 .782 0 1.761 1.682 2.798 3.463 1.11 1.905 2.49 4.277 4.525 6.311.178.18.401.386.65.607 1.184 1.053 1.363 2.85.41 4.09l-.084.108a1.07 1.07 0 0 1-1.352.294 87 87 0 0 0-1.272-.664c-1.493-.77-3.537-1.825-5.12-2.886a1.63 1.63 0 0 0-1.95.094 1.62 1.62 0 0 0-.47 1.88c.856 2.065 2.729 5.104 2.809 5.232a1 1 0 0 0 1.702-1.05c-.015-.025-1.256-2.038-2.142-3.819 1.443.876 3.029 1.694 4.254 2.327.472.243.895.462 1.243.65a3.06 3.06 0 0 0 3.882-.836l.084-.109c1.59-2.068 1.298-5.057-.665-6.804z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-horse-head_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHorseHead;
